import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './Dashboard';
import Login from './Login';
import Users from './Admin/Users';
import Password from './Admin/ChangePassword';
import Transactions from './Account/Transactions';
import Cashout from './Account/Cashout';
import PendingBal from './Account/PendingBal';
import Link from './Link/Link';
import About from './About/About';
import Admin from './Admin/AdminDashboard';

function App() {

    return (
        <BrowserRouter>
            <div className='App'>
                <Routes>
                    <Route path='/' element={<Login/>}></Route>
                    <Route path='/dashboard' element={<Dashboard />}></Route>                 
                    <Route path='/transactions' element={<Transactions />}></Route>                 
                    <Route path='/cashout' element={<Cashout />}></Route>                 
                    <Route path='/pendingbalance' element={<PendingBal />}></Route>                 
                    {/* <Route path='/mylink' element={<Link/>}></Route> */}
                    <Route path='/about' element={<About/>}></Route>
                    {/* <Route path='/users' element={<Users/>}></Route> */}
                    <Route path='/admin' element={<Admin/>}></Route>
                    <Route path='/changepassword' element={<Password/>}></Route>
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;